<template>

    <Collapse>
        <Panel name="Section.Title">
			Options
                    <div @click="Click" slot="content">
				        <Icon type="md-print" /> Print This Page
                    </div>

        </Panel>
	</Collapse>
</template>




<script>
export default {
    name: 'ListingPrinting' ,
    methods: {
        Click() {
            var scs = []
            this.Items.forEach(function(i) {
                scs.push(i.StyleCode);
            }) 
            window.open('/lb/print/#' + scs.join(','));
        }
    },
    props: {
        Items: Array
    }
}
</script>